var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7697 6.01002L13.2197 0.770018C11.9397 -0.249982 9.93966 -0.259982 8.66966 0.760018L2.11966 6.01002C1.17966 6.76002 0.60966 8.26002 0.80966 9.44002L2.06966 16.98C2.35966 18.67 3.92966 20 5.63966 20H16.2397C17.9297 20 19.5297 18.64 19.8197 16.97L21.0797 9.43002C21.2597 8.26002 20.6897 6.76002 19.7697 6.01002ZM11.6897 16C11.6897 16.41 11.3497 16.75 10.9397 16.75C10.5297 16.75 10.1897 16.41 10.1897 16V13C10.1897 12.59 10.5297 12.25 10.9397 12.25C11.3497 12.25 11.6897 12.59 11.6897 13V16Z",
    fill: "#873BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0b7647dd402bedae7a1b7f7e3e5c79fb.svg";
export { ForwardRef as ReactComponent };